import { Component, OnInit } from '@angular/core';
import { BaseEditor } from '../base-editor';
import { EditorService } from '../services/editor.service';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { DynamicInputComponent, MenuGroup } from '../dynamic-input-model';
import { BlogEditorInputComponent } from './blog-editor-input/blog-editor-input.component';

@Component({
  selector: 'ngx-blog-editor',
  templateUrl: './blog-editor.component.html',
  styleUrls: ['./blog-editor.component.scss']
})
export class BlogEditorComponent extends BaseEditor implements OnInit {
  inputComponent = new DynamicInputComponent(BlogEditorInputComponent);
  
  title = "Editing Blog Route";
  menuTag = "editBlogsPageRouteMenu";

  menuGroup:MenuGroup = {
    title:"Editing Blog Route",
    menuTag:"editBlogsPageRouteMenu",
    menuItems: [
      {
        title:"Page Settings"
      },
      {
        title:"Sections"
      },
      {
        title:'Add Section',
        children:[
          {
            title:'Grid',
            children:[
              {
                title:'Add New Grid'
              },
              {
                title:'Edit Existing Grid'
              }
            ]
          },
          {
            title:'Banner'
          },
          {
            title:'Slider'
          },
          {
            title:'Slide Show'
          }
        ]
      },
      {
        title:'Remove Section',
      },
      {
        title:'Order Sections',
      },
    ]
  }
  menuItems:NbMenuItem[] = [
    {
      title:'Settings'
    },
    {
      title:'Sections'
    },
    {
      title:'Add Section',
    },
    {
      title:'Remove Section'
    },
    {
      title:'Order Sections'
    }
  ]
  previousMenu:NbMenuItem[] = [];

  constructor(editorService:EditorService,
    menuService:NbMenuService){
      super(editorService,menuService)
    }


  ngOnInit(): void {
    super.ngOnInit()
  }

}
